ArrayPathLayer = require './array-path-layer'

module.exports = App.PolylineLayerComponent = ArrayPathLayer.extend
  leafletOptions: [
    'smoothFactor'
    'noClip'
  ]
  createLayer: ->
    @L.polyline.apply @L, @get('requiredOptions').concat([ @get('options') ])